module.exports = __webpack_public_path__ + "assets/img/2212.69a47c9f.png";